"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  SmartHouseLightOn: ['smart-house-light-on', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.108,5.768a.252.252,0,0,1-.1-.2V4.5a1,1,0,0,0-.4-.8.252.252,0,0,1-.1-.2V2.25A.25.25,0,0,1,7.754,2h9.5a.25.25,0,0,1,.25.25V3.5a.032.032,0,0,1-.033.032h-.863a.82.82,0,0,0-.782.427.822.822,0,0,0,.14.88l1.755,2.277a.962.962,0,0,0,1.564,0l1.757-2.278a.821.821,0,0,0,.139-.88.82.82,0,0,0-.781-.427h-.864A.032.032,0,0,1,19.5,3.5V1a1,1,0,0,0-1-1H6.5a1,1,0,0,0-1,1V3.5a.252.252,0,0,1-.1.2,1,1,0,0,0-.4.8V5.565a.25.25,0,0,1-.1.2,2.75,2.75,0,1,0,3.208,0Z', 'M6.5,11.75a.75.75,0,0,0-.75.75v1a.75.75,0,0,0,1.5,0v-1A.75.75,0,0,0,6.5,11.75Z', 'M9.473,10.97a.749.749,0,0,0,0,1.06l.5.5a.75.75,0,1,0,1.061-1.06l-.5-.5A.75.75,0,0,0,9.473,10.97Z', 'M12.754,8A.75.75,0,0,0,12,7.25H11a.75.75,0,1,0,0,1.5h1A.75.75,0,0,0,12.754,8Z', 'M2.473,10.97l-.5.5a.75.75,0,0,0,1.061,1.06l.5-.5a.75.75,0,0,0-1.061-1.06Z', 'M2.754,8A.75.75,0,0,0,2,7.25H1a.75.75,0,1,0,0,1.5H2A.75.75,0,0,0,2.754,8Z', 'M14.192,21.489a.25.25,0,0,1-.056-.452,2.85,2.85,0,1,0-2.972,0,.25.25,0,0,1-.057.452,5.163,5.163,0,0,0-2.492,1.7A.5.5,0,0,0,9,24H16.3a.5.5,0,0,0,.389-.814A5.165,5.165,0,0,0,14.192,21.489Z', 'M16.382,8.31a1,1,0,0,0-1.414,1.415,5,5,0,0,0,7.071,0A1,1,0,1,0,20.625,8.31,3.073,3.073,0,0,1,16.382,8.31Z', 'M23.453,11.554a1,1,0,0,0-1.414,0,5.006,5.006,0,0,1-7.071,0,1,1,0,1,0-1.414,1.414,7.007,7.007,0,0,0,9.9,0A1,1,0,0,0,23.453,11.554Z']],
  SmartHouseLight: ['smart-house-light', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.250 7.500 A1.750 1.750 0 1 0 16.750 7.500 A1.750 1.750 0 1 0 13.250 7.500 Z', 'M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882Zm-7.147,3.432a.25.25,0,0,0-.125.216v.72a1.25,1.25,0,0,1-.625,1.082.252.252,0,0,0-.125.217v.2a.75.75,0,0,1-1.5,0v-.2a.251.251,0,0,0-.125-.217A1.25,1.25,0,0,1,13.5,11.25v-.72a.25.25,0,0,0-.125-.216,3.25,3.25,0,1,1,3.25,0Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M6.5,17a1.752,1.752,0,0,0-1.75-1.75h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25ZM5,22.25a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHouseOpenDoor: ['smart-house-open-door', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.56,12.4a1,1,0,0,0-1,1v5.75a.25.25,0,0,1-.25.25H8.81a.25.25,0,0,1-.25-.25V5.712a1.493,1.493,0,0,0-.829-1.341l-.986-.494A.249.249,0,0,1,6.856,3.4h4.7a1,1,0,0,0,0-2h-10a1.012,1.012,0,0,0-1,1V20.1a1.5,1.5,0,0,0,.829,1.342h0l5,2.5a1.514,1.514,0,0,0,.669.158,1.5,1.5,0,0,0,1.5-1.5v-.941a.25.25,0,0,1,.25-.25h3.25a1.5,1.5,0,0,0,1.5-1.5V13.4A1,1,0,0,0,12.56,12.4Z', 'M14.56,1.4a1.5,1.5,0,0,0,1.5,1.5h3a1.5,1.5,0,0,0,1.5-1.5V.4a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5Z', 'M14.157,6.348a4.859,4.859,0,0,0,6.873,0,1,1,0,1,0-1.414-1.414,2.928,2.928,0,0,1-4.045,0,1,1,0,0,0-1.414,1.414Z', 'M21.733,7.817a5.906,5.906,0,0,1-8.341,0,1,1,0,0,0-1.414,1.414,7.908,7.908,0,0,0,11.169,0,1,1,0,0,0-1.414-1.414Z']],
  SmartHouseCall: ['smart-house-call', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882ZM19.48,11.817a1.031,1.031,0,0,1-.624.754,5.762,5.762,0,0,1-2.168.434,5.592,5.592,0,0,1-3.982-1.71,5.817,5.817,0,0,1-1.274-6.316,1.031,1.031,0,0,1,1.686-.342l1.551,1.551a1.414,1.414,0,0,1,0,2l-.358.358a2.09,2.09,0,0,1-1.439.693.25.25,0,0,0-.212.376,4.8,4.8,0,0,0,.753.975,5.079,5.079,0,0,0,.977.767.25.25,0,0,0,.379-.212c0-.041,0-.082,0-.124a2.129,2.129,0,0,1,.684-1.328l.359-.359a1.414,1.414,0,0,1,2,0l1.4,1.57A1.022,1.022,0,0,1,19.48,11.817Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHouseTimerAlternate: ['smart-house-timer-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M18.555,15.7a.75.75,0,0,0-1.056.1c-.1.116-.2.23-.3.341a.75.75,0,0,0,1.088,1.032c.128-.135.252-.274.37-.417A.75.75,0,0,0,18.555,15.7Z', 'M19.817,12.147a.752.752,0,0,0-.876.6,6.5,6.5,0,0,1-.212.823.751.751,0,0,0,1.428.463,8.317,8.317,0,0,0,.257-1.006A.749.749,0,0,0,19.817,12.147Z', 'M18.932,10.127a.75.75,0,0,0,1.472-.29,8.245,8.245,0,0,0-.822-2.3.75.75,0,1,0-1.322.707A6.757,6.757,0,0,1,18.932,10.127Z', 'M17.487,6.425a.75.75,0,0,0-.129-1.053A8.317,8.317,0,0,0,6.207,17.652.75.75,0,0,0,7.3,16.621,6.817,6.817,0,0,1,16.435,6.555.75.75,0,0,0,17.487,6.425Z', 'M11,8.749H9.778a1.746,1.746,0,0,0-1.7,1.325l-.811,3.242A.751.751,0,0,0,8,14.249h2.25V15.5a.75.75,0,0,0,1.5,0v-6A.75.75,0,0,0,11,8.749Zm-.75,3.75a.25.25,0,0,1-.25.25H9.281a.248.248,0,0,1-.2-.1.251.251,0,0,1-.045-.215l.5-2a.25.25,0,0,1,.241-.189H10a.249.249,0,0,1,.25.25Z', 'M16,10.249a.75.75,0,0,0,0-1.5H13.5a.75.75,0,0,0-.75.75v2.313a1.439,1.439,0,0,0,1.437,1.437H14.5a.75.75,0,0,1,0,1.5h-1a.75.75,0,1,0,0,1.5h1a2.25,2.25,0,1,0,0-4.5.2.2,0,0,1-.173-.037.2.2,0,0,1-.077-.158V10.5a.25.25,0,0,1,.25-.25Z']],
  SmartHouse: ['smart-house', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,23a1,1,0,0,0-1-1H12.75a.25.25,0,0,1-.25-.25v-3a.25.25,0,0,1,.25-.25H18.5A1.5,1.5,0,0,0,20,17V10.707a.25.25,0,0,1,.427-.177l1.543,1.543a.75.75,0,1,0,1.06-1.061L12.384.366a1.251,1.251,0,0,0-1.768,0L.22,10.762a.75.75,0,0,0,1.06,1.061L2.573,10.53A.25.25,0,0,1,3,10.707V17a1.5,1.5,0,0,0,1.5,1.5h5.75a.25.25,0,0,1,.25.25v3a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H23A1,1,0,0,0,24,23ZM9.5,17a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5v5a.5.5,0,0,1-.5.5Z']],
  SmartHouseEye: ['smart-house-eye', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.75A.25.25,0,0,1,9,8.25v6.116A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.25A.25.25,0,0,1,21.25,8h2.107a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882ZM18.608,9.933A5.24,5.24,0,0,1,15,11.5a5.24,5.24,0,0,1-3.608-1.567,1.306,1.306,0,0,1,0-1.866A5.24,5.24,0,0,1,15,6.5a5.24,5.24,0,0,1,3.608,1.567,1.306,1.306,0,0,1,0,1.866Z', 'M13.750 9.000 A1.250 1.250 0 1 0 16.250 9.000 A1.250 1.250 0 1 0 13.750 9.000 Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHouseDoorOpen: ['smart-house-door-open', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.500 5.500 L17.500 5.500 L17.500 11.500 L15.500 11.500 Z', 'M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882ZM18.5,12a.5.5,0,0,1-.5.5H15.5V13a.5.5,0,0,1-.237.425A.5.5,0,0,1,15,13.5a.508.508,0,0,1-.224-.053l-3-1.5A.5.5,0,0,1,11.5,11.5v-6a.5.5,0,0,1,.276-.447l3-1.5A.5.5,0,0,1,15.5,4v.5H18a.5.5,0,0,1,.5.5Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHouseDoor: ['smart-house-door', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882ZM18,12.5a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5V5a.5.5,0,0,1,.5-.5h5A.5.5,0,0,1,18,5Z', 'M15.500 8.984 A0.75 0.703 0 1 0 17.000 8.984 A0.75 0.703 0 1 0 15.500 8.984 Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHousePhoneConnect: ['smart-house-phone-connect', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.3,13.148a8.021,8.021,0,0,1-.294-2.156,1,1,0,0,0-2,0,10.04,10.04,0,0,0,.366,2.692A1,1,0,0,0,4.3,13.148Z', 'M7.093,17.3A8.136,8.136,0,0,1,5.6,15.781a1,1,0,1,0-1.6,1.2,10.1,10.1,0,0,0,1.864,1.9A1,1,0,1,0,7.093,17.3Z', 'M12,18.986a8,8,0,0,1-2.253-.322,1,1,0,0,0-.561,1.919,10.048,10.048,0,0,0,2.814.4,1,1,0,0,0,0-2Z', 'M19.266,7.652a8.024,8.024,0,0,1,.553,1.666A1,1,0,1,0,21.773,8.9a9.909,9.909,0,0,0-.692-2.085,1,1,0,1,0-1.815.835Z', 'M16.483,4.371a8.137,8.137,0,0,1,1.122.921,1,1,0,1,0,1.4-1.424,10.081,10.081,0,0,0-1.4-1.148,1,1,0,1,0-1.125,1.651Z', 'M14.88,2.41a1,1,0,0,0-.767-1.187,10.242,10.242,0,0,0-3.271-.159,1,1,0,1,0,.225,1.987,8.111,8.111,0,0,1,2.626.126A1,1,0,0,0,14.88,2.41Z', 'M9.481,4.278a.331.331,0,0,0-.1-.369L4.975.079a.345.345,0,0,0-.439,0L.129,3.909a.329.329,0,0,0-.1.369A.339.339,0,0,0,.348,4.5h.91a.25.25,0,0,1,.25.25V7.994a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V6.745a1.25,1.25,0,0,1,2.5,0V7.994a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V4.747a.25.25,0,0,1,.25-.25h.91A.339.339,0,0,0,9.481,4.278Z', 'M22.518,12.009H17.47A1.491,1.491,0,0,0,16,13.516v8.977A1.493,1.493,0,0,0,17.47,24h5.048a1.492,1.492,0,0,0,1.473-1.507V13.516A1.492,1.492,0,0,0,22.518,12.009ZM21.993,20.5a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5V14.525a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Z']],
  SmartHousePhoneSync: ['smart-house-phone-sync', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,5V6.25a.25.25,0,0,1-.25.25H16.5a.5.5,0,0,0-.354.853l2.5,2.5a.5.5,0,0,0,.708,0l2.5-2.5A.5.5,0,0,0,21.5,6.5H20.25A.25.25,0,0,1,20,6.25V5a4,4,0,0,0-4-4H13.5a1,1,0,0,0,0,2H16A2,2,0,0,1,18,5Z', 'M13,18a1,1,0,0,0-1-1H8a2,2,0,0,1-2-2V13.75a.25.25,0,0,1,.25-.25H7.5a.5.5,0,0,0,.354-.854l-2.5-2.5a.5.5,0,0,0-.708,0l-2.5,2.5A.5.5,0,0,0,2.5,13.5H3.75a.25.25,0,0,1,.25.25V15a4,4,0,0,0,4,4h4A1,1,0,0,0,13,18Z', 'M22.526,12H17.474A1.493,1.493,0,0,0,16,13.508v8.983A1.493,1.493,0,0,0,17.474,24h5.052A1.493,1.493,0,0,0,24,22.491V13.508A1.493,1.493,0,0,0,22.526,12ZM22,20.5a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5V14.518a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Z', 'M3,8.5A.5.5,0,0,0,3.5,8V6.75a1.25,1.25,0,0,1,2.5,0V8a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,8,8V4.75a.25.25,0,0,1,.25-.25h.911a.338.338,0,0,0,.318-.219.329.329,0,0,0-.1-.369L4.969.079a.344.344,0,0,0-.438,0L.12,3.912a.329.329,0,0,0-.1.369A.338.338,0,0,0,.339,4.5H1.25a.25.25,0,0,1,.25.25V8a.5.5,0,0,0,.5.5Z']],
  SmartHouseUnlock: ['smart-house-unlock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882ZM18.5,11.52a1.5,1.5,0,0,1-1.5,1.5H13a1.5,1.5,0,0,1-1.5-1.5v-3A1.5,1.5,0,0,1,13,7.02h3.25a.25.25,0,0,0,.25-.25V6.5a1.5,1.5,0,0,0-2.56-1.061.5.5,0,1,1-.708-.706A2.477,2.477,0,0,1,15,4a2.5,2.5,0,0,1,2.5,2.5v.439a.252.252,0,0,0,.143.226A1.5,1.5,0,0,1,18.5,8.52Z', 'M14.000 10.020 A1.000 1.000 0 1 0 16.000 10.020 A1.000 1.000 0 1 0 14.000 10.020 Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHouseTemperature: ['smart-house-temperature', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.5,4.5A.5.5,0,0,0,14,5V8.25a.25.25,0,0,0,.25.25h.5A.25.25,0,0,0,15,8.25V5A.5.5,0,0,0,14.5,4.5Z', 'M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882ZM14.5,13.5a2,2,0,0,1-1.555-3.257A.245.245,0,0,0,13,10.087V5a1.5,1.5,0,0,1,3,0v5.087a.251.251,0,0,0,.055.156A2,2,0,0,1,14.5,13.5Zm4-4.5h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Zm0-2h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHouseVentilator: ['smart-house-ventilator', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882Zm-5.133,1.16a2.091,2.091,0,0,1-1.8.949.251.251,0,0,0-.2.113.248.248,0,0,0-.025.224l1.252,3.337a.251.251,0,0,1-.232.338,2.621,2.621,0,0,1-1.685-.364,2.1,2.1,0,0,1-.949-1.8.249.249,0,0,0-.337-.22l-3.337,1.252A.251.251,0,0,1,11,11.643a2.63,2.63,0,0,1,.364-1.685,2.091,2.091,0,0,1,1.8-.949.251.251,0,0,0,.2-.113.248.248,0,0,0,.025-.224L12.126,5.335a.249.249,0,0,1,.027-.229.251.251,0,0,1,.2-.109,2.62,2.62,0,0,1,1.685.364,2.1,2.1,0,0,1,.949,1.8.249.249,0,0,0,.337.22l3.337-1.252A.251.251,0,0,1,19,6.356,2.615,2.615,0,0,1,18.639,8.042Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHouseWindow: ['smart-house-window', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.919,9.674A2.447,2.447,0,0,1,9.4,8.9a.25.25,0,0,0-.23-.152H8.5A.25.25,0,0,0,8.25,9v6.25a.25.25,0,0,0,.25.25h6.25a.25.25,0,0,0,.25-.25V12.676a.249.249,0,0,0-.19-.242A10.419,10.419,0,0,1,9.919,9.674Z', 'M6.5,15.5a.25.25,0,0,0,.25-.25V9a.25.25,0,0,0-.25-.25h-5A1.5,1.5,0,0,0,0,10.25v5a.25.25,0,0,0,.25.25Z', 'M8.5,17a.25.25,0,0,0-.25.25V23.5a.25.25,0,0,0,.25.25h5a1.5,1.5,0,0,0,1.5-1.5v-5a.25.25,0,0,0-.25-.25Z', 'M6.75,17.25A.25.25,0,0,0,6.5,17H.25a.25.25,0,0,0-.25.25v5a1.5,1.5,0,0,0,1.5,1.5h5a.25.25,0,0,0,.25-.25Z', 'M17.343,2.834a2.992,2.992,0,0,0,2.122-.877A1,1,0,1,0,18.051.543a1,1,0,0,1-1.415,0,1,1,0,1,0-1.414,1.414A2.99,2.99,0,0,0,17.343,2.834Z', 'M17.343,6.835a5.965,5.965,0,0,0,4.243-1.757,1,1,0,0,0-1.414-1.414,4,4,0,0,1-5.657,0A1,1,0,1,0,13.1,5.078,5.957,5.957,0,0,0,17.343,6.835Z', 'M17.343,10.831A8.976,8.976,0,0,0,23.707,8.2a1,1,0,1,0-1.414-1.414,7.008,7.008,0,0,1-9.9,0A1,1,0,1,0,10.979,8.2,8.976,8.976,0,0,0,17.343,10.831Z']],
  SmartHousePhone: ['smart-house-phone', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.825,16.584a.154.154,0,0,0-.1-.273H2.479a.414.414,0,0,1-.417-.411V3.16a.414.414,0,0,1,.417-.411h9.167a.413.413,0,0,1,.416.411V8a.251.251,0,0,0,.367.221,3.446,3.446,0,0,1,.934-.335.25.25,0,0,0,.2-.245V2.749A2.44,2.44,0,0,0,11.125.311H3A2.441,2.441,0,0,0,.562,2.749V17.374A2.44,2.44,0,0,0,3,19.811H5.325a.248.248,0,0,0,.183-.08.244.244,0,0,0,.066-.189A3.5,3.5,0,0,1,6.825,16.584Z', 'M23.438,21.811a4.881,4.881,0,0,0-4.876-4.875H16.438V11.311a2.375,2.375,0,1,0-4.75,0v6.715a.251.251,0,0,1-.443.16l-.356-.428a2.375,2.375,0,1,0-3.653,3.036l2.143,2.577a.875.875,0,0,0,1.346-1.119L8.582,19.675a.625.625,0,1,1,.961-.8L11.89,21.7a.875.875,0,0,0,1.548-.559V11.311a.625.625,0,1,1,1.25,0v6.5a.874.874,0,0,0,.874.875h3a3.13,3.13,0,0,1,3.126,3.125v1a.875.875,0,1,0,1.75,0Z', 'M10.98,9.33,7.463,6.708a.233.233,0,0,0-.3,0L3.645,9.33a.224.224,0,0,0-.068.253.231.231,0,0,0,.218.15H4.839a.249.249,0,0,1,.25.25v2.144a.342.342,0,0,0,.342.342h.881a.249.249,0,0,0,.25-.25v-.908a.75.75,0,1,1,1.5,0v.908a.25.25,0,0,0,.25.25h.882a.343.343,0,0,0,.342-.342V9.983a.249.249,0,0,1,.25-.25H10.83a.235.235,0,0,0,.218-.15A.228.228,0,0,0,10.98,9.33Z']],
  SmartHouseRemote: ['smart-house-remote', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882Zm-4.915,4.623a.992.992,0,0,1-.989.995H12.132a.993.993,0,0,1-.989-.995V8.788a.165.165,0,0,1,.252-.141l2.819,2.043a1.48,1.48,0,0,0,1.572,0l2.819-2.043a.165.165,0,0,1,.252.141Zm-.023-4.527L15.262,9.351a.522.522,0,0,1-.524,0L11.166,6.978a.046.046,0,0,1-.023-.04A.966.966,0,0,1,12.132,6h5.736a.965.965,0,0,1,.989.938A.045.045,0,0,1,18.834,6.978Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHouseLock: ['smart-house-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15,5a1.5,1.5,0,0,0-1.5,1.5v.25a.25.25,0,0,0,.25.25h2.5a.25.25,0,0,0,.25-.25V6.5A1.5,1.5,0,0,0,15,5Z', 'M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882ZM18.5,11.52a1.5,1.5,0,0,1-1.5,1.5H13a1.5,1.5,0,0,1-1.5-1.5v-3a1.5,1.5,0,0,1,.857-1.355.252.252,0,0,0,.143-.226V6.5a2.5,2.5,0,0,1,5,0v.439a.252.252,0,0,0,.143.226A1.5,1.5,0,0,1,18.5,8.52Z', 'M14.000 10.020 A1.000 1.000 0 1 0 16.000 10.020 A1.000 1.000 0 1 0 14.000 10.020 Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHouseBell: ['smart-house-bell', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.772,6.882,15.416.15a.65.65,0,0,0-.831,0L6.228,6.882a.63.63,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882ZM16.3,12.75a1.5,1.5,0,0,1-2.6,0,.5.5,0,0,1,.433-.75h1.733a.5.5,0,0,1,.432.75ZM18.5,11h-7a.5.5,0,0,1,0-1,.5.5,0,0,0,.5-.5v-2a3,3,0,0,1,6,0v2a.5.5,0,0,0,.5.5.5.5,0,0,1,0,1Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHouseOpen: ['smart-house-open', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.757,8.712a.248.248,0,0,0-.142-.044H1.5a1.5,1.5,0,0,0-1.5,1.5v12a1.5,1.5,0,0,0,1.5,1.5h8a1.5,1.5,0,0,0,1.5-1.5V10.841a.25.25,0,0,0-.222-.248A10.961,10.961,0,0,1,5.757,8.712Zm.95,8.749a1,1,0,1,1-1.414,1.414l-2-2a1,1,0,0,1,0-1.414l2-2a1,1,0,1,1,1.414,1.414L5.591,15.991a.25.25,0,0,0,0,.354Z', 'M24,10.168a1.5,1.5,0,0,0-1.5-1.5H18.385a.251.251,0,0,0-.142.044,10.961,10.961,0,0,1-5.021,1.881.249.249,0,0,0-.222.248V22.168a1.5,1.5,0,0,0,1.5,1.5h8a1.5,1.5,0,0,0,1.5-1.5Zm-6.707,4.707a1,1,0,1,1,1.414-1.414l2,2a1,1,0,0,1,0,1.414l-2,2a1,1,0,0,1-1.414-1.414l1.116-1.116a.25.25,0,0,0,0-.354Z', 'M12,2.416a2.741,2.741,0,0,0,1.944-.8.75.75,0,1,0-1.06-1.06,1.252,1.252,0,0,1-1.768,0,.75.75,0,1,0-1.06,1.06A2.741,2.741,0,0,0,12,2.416Z', 'M7.935,3.734A5.71,5.71,0,0,0,12,5.418a5.71,5.71,0,0,0,4.065-1.684.776.776,0,0,0,0-1.061.749.749,0,0,0-1.06,0A4.222,4.222,0,0,1,12,3.918,4.222,4.222,0,0,1,8.995,2.673a.749.749,0,0,0-1.06,0A.776.776,0,0,0,7.935,3.734Z', 'M18.187,4.794a.749.749,0,0,0-1.06,0,7.259,7.259,0,0,1-10.254,0A.75.75,0,0,0,5.812,5.855,8.73,8.73,0,0,0,12,8.414a8.726,8.726,0,0,0,6.187-2.559A.75.75,0,0,0,18.187,4.794Z']],
  SmartHousePower: ['smart-house-power', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882ZM14.5,5.5a.5.5,0,0,1,1,0v4a.5.5,0,0,1-1,0ZM15,13a3.5,3.5,0,0,1-2.333-6.108.5.5,0,1,1,.666.745,2.5,2.5,0,1,0,3.334,0,.5.5,0,1,1,.666-.745A3.5,3.5,0,0,1,15,13Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHouseCar: ['smart-house-car', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.281,10.5h.469a.25.25,0,0,0,.25-.25V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416.628.628,0,0,0-.189-.7L9.416.15a.652.652,0,0,0-.832,0L.228,6.882a.628.628,0,0,0-.189.7A.643.643,0,0,0,.643,8H2.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,3.643,15h6.975a.25.25,0,0,0,.243-.189l.509-2.039A3,3,0,0,1,14.281,10.5ZM4.416,7.187a.751.751,0,0,1,.113-1.055,7.068,7.068,0,0,1,8.942,0A.75.75,0,1,1,12.529,7.3a5.58,5.58,0,0,0-7.058,0A.751.751,0,0,1,4.416,7.187ZM9,12.5a1,1,0,1,1,1-1A1,1,0,0,1,9,12.5Zm1.862-2.791a2.946,2.946,0,0,0-3.724,0A.75.75,0,1,1,6.2,8.542a4.432,4.432,0,0,1,5.608,0,.75.75,0,1,1-.942,1.167Z', 'M23.561,17.854,22.1,16.388a.25.25,0,0,1-.066-.116l-.78-3.119a1.886,1.886,0,0,0-1.832-1.431H14.583a1.885,1.885,0,0,0-1.832,1.431l-.78,3.119a.25.25,0,0,1-.066.116l-1.466,1.466A1.49,1.49,0,0,0,10,18.914V20.5a1.5,1.5,0,0,0,1.286,1.485.249.249,0,0,1,.214.247V23a1,1,0,0,0,2,0v-.75a.25.25,0,0,1,.25-.25h6.5a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0v-.768a.249.249,0,0,1,.214-.247A1.5,1.5,0,0,0,24,20.5V18.914A1.49,1.49,0,0,0,23.561,17.854ZM19.6,15.182a.253.253,0,0,1-.2.1H14.6a.249.249,0,0,1-.242-.311l.264-1.055a.248.248,0,0,1,.242-.19h4.27a.248.248,0,0,1,.242.19l.264,1.055A.251.251,0,0,1,19.6,15.182Z']],
  SmartHousePhoneLock1: ['smart-house-phone-lock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.279,10.505a.249.249,0,0,0,.221-.248V9.721a.25.25,0,0,1,.25-.25h1.938a.729.729,0,0,0,.471-1.286L10.68.164a.728.728,0,0,0-.943,0L.258,8.185A.73.73,0,0,0,.73,9.471H2.75a.25.25,0,0,1,.25.25v7.041a.729.729,0,0,0,.729.729H14.25a.249.249,0,0,0,.25-.25v-3.75A2.956,2.956,0,0,1,17.279,10.505ZM13.5,11.991a1,1,0,0,1-1,1h-4a1,1,0,0,1-1-1v-3a1,1,0,0,1,.4-.8.249.249,0,0,0,.1-.2v-.5a2.5,2.5,0,0,1,5,0v.5a.249.249,0,0,0,.1.2,1,1,0,0,1,.4.8Z', 'M12,7.491a1.5,1.5,0,0,0-3,0v.25a.25.25,0,0,0,.25.25h2.5a.25.25,0,0,0,.25-.25Z', 'M10.5,9.53a.981.981,0,1,0,.98.981A.98.98,0,0,0,10.5,9.53Z', 'M22.526,12.009H17.474A1.5,1.5,0,0,0,16,13.518V22.5a1.493,1.493,0,0,0,1.474,1.509h5.052A1.493,1.493,0,0,0,24,22.5V13.518A1.493,1.493,0,0,0,22.526,12.009ZM18,20.509V14.527a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v5.982a.5.5,0,0,1-.5.5h-3A.5.5,0,0,1,18,20.509Z']],
  SmartHousePhoneRemote: ['smart-house-phone-remote', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.7,9.6,12.554.2a.859.859,0,0,0-1.108,0L.3,9.6A.854.854,0,0,0,.858,11.1H3.026a.5.5,0,0,1,.5.5v8.041a.857.857,0,0,0,.858.855H7.25a.25.25,0,0,0,.25-.25v-4a2.994,2.994,0,0,1,1.231-2.42.25.25,0,0,0,.083-.3,2.057,2.057,0,0,1-.129-.458.249.249,0,0,0-.129-.182A2,2,0,0,1,8.249,9.57a6.159,6.159,0,0,1,7.5,0,2,2,0,0,1-.307,3.323.251.251,0,0,0-.129.182,2.057,2.057,0,0,1-.129.458.249.249,0,0,0,.083.3A3,3,0,0,1,16.5,16.252v4a.25.25,0,0,0,.25.25h2.964a.856.856,0,0,0,.857-.855V11.6a.5.5,0,0,1,.5-.5h2.071A.854.854,0,0,0,23.7,9.6Z', 'M11.164,13.574a1.281,1.281,0,0,1,1.672,0,.751.751,0,0,0,1-1.116,2.822,2.822,0,0,0-3.68,0,.751.751,0,0,0,1,1.116Z', 'M9.969,11.661a3.3,3.3,0,0,1,4.062,0,.75.75,0,0,0,.938-1.17,4.871,4.871,0,0,0-5.938,0,.75.75,0,0,0,.938,1.17Z', 'M15.25,16.252A1.753,1.753,0,0,0,13.5,14.5h-3a1.753,1.753,0,0,0-1.75,1.75v6A1.752,1.752,0,0,0,10.5,24h3a1.752,1.752,0,0,0,1.75-1.75ZM13.5,22.5h-3a.25.25,0,0,1-.25-.25v-6A.251.251,0,0,1,10.5,16h3a.251.251,0,0,1,.25.25v6A.25.25,0,0,1,13.5,22.5Z']],
  SmartHousePhoneCctv: ['smart-house-phone-cctv', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.026,11.661H16.974A1.493,1.493,0,0,0,15.5,13.17v8.983a1.493,1.493,0,0,0,1.474,1.508h5.052A1.493,1.493,0,0,0,23.5,22.153V13.17A1.493,1.493,0,0,0,22.026,11.661Zm-.526,8.5a.5.5,0,0,1-.5.5H18a.5.5,0,0,1-.5-.5V14.179a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Z', 'M12.453,5.757l-2.591.8A.1.1,0,0,1,9.753,6.5l-.286-.922a.25.25,0,0,1,.109-.288A2.671,2.671,0,0,0,7.4.459L1.083,2.418a.783.783,0,0,0-.4,1.263l2.3,2.969a1.19,1.19,0,0,0,1.234.388L7.27,6.093a.25.25,0,0,1,.313.164l.26.84a2.089,2.089,0,0,0,2.61,1.374l2.592-.8a1,1,0,1,0-.592-1.91Z', 'M18.5,5.338v1.25a.25.25,0,0,1-.25.25H17a.5.5,0,0,0-.353.854l2.5,2.5a.5.5,0,0,0,.707,0l2.5-2.5A.5.5,0,0,0,22,6.838H20.75a.25.25,0,0,1-.25-.25V5.338a4,4,0,0,0-4-4H14a1,1,0,0,0,0,2h2.5A2,2,0,0,1,18.5,5.338Z', 'M12.5,17.338h-4a2,2,0,0,1-2-2v-1.25a.25.25,0,0,1,.25-.25H8a.5.5,0,0,0,.354-.853l-2.5-2.5a.5.5,0,0,0-.707,0l-2.5,2.5A.5.5,0,0,0,3,13.838H4.25a.25.25,0,0,1,.25.25v1.25a4,4,0,0,0,4,4h4a1,1,0,0,0,0-2Z']],
  SmartHouseWater: ['smart-house-water', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882ZM12,13.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,12,13.5Zm7-5a.5.5,0,0,1-.5.5h-4A1.5,1.5,0,0,0,13,10.479a.509.509,0,0,1-.5.521h-1a.507.507,0,0,1-.5-.522,3.552,3.552,0,0,1,3.263-3.472.249.249,0,0,0,.237-.249V5.75a.25.25,0,0,0-.25-.25H13a.5.5,0,0,1,0-1h4a.5.5,0,0,1,0,1H15.75a.25.25,0,0,0-.25.25v1a.25.25,0,0,0,.25.25H18.5a.5.5,0,0,1,.5.5Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHousePlay: ['smart-house-play', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.773,6.882,15.416.15a.65.65,0,0,0-.831,0L6.228,6.882a.628.628,0,0,0-.188.7.641.641,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.773,6.882ZM15,12a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,15,12Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z', 'M13.952,8.5V7.287a.287.287,0,0,1,.434-.246l2.023,1.213a.287.287,0,0,1,0,.492L14.386,9.959a.287.287,0,0,1-.434-.246Z']],
  SmartHouseMusic: ['smart-house-music', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.773,6.882,15.416.15a.65.65,0,0,0-.831,0L6.228,6.882a.63.63,0,0,0-.189.7.643.643,0,0,0,.6.416H8.5a.5.5,0,0,1,.5.5v5.866A.639.639,0,0,0,9.643,15H20.357A.638.638,0,0,0,21,14.366V8.5a.5.5,0,0,1,.5-.5h1.857a.643.643,0,0,0,.6-.416A.629.629,0,0,0,23.773,6.882ZM19.25,10A1.75,1.75,0,1,1,17.5,8.25.249.249,0,0,0,17.75,8V5.955a.25.25,0,0,0-.3-.247l-3.408,1.1c-.21.045-.3.149-.3.27V12A1.75,1.75,0,1,1,12,10.25h.028a.219.219,0,0,0,.222-.219V7.08a1.754,1.754,0,0,1,1.428-1.721l3.409-1.1a1.768,1.768,0,0,1,1.531.351,1.74,1.74,0,0,1,.632,1.347Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']],
  SmartHouseTimer: ['smart-house-timer', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.539,10.439l-.5,2a.251.251,0,0,0,.045.215.248.248,0,0,0,.2.1H9.5a.25.25,0,0,0,.25-.25v-2a.249.249,0,0,0-.25-.25H8.78A.251.251,0,0,0,8.539,10.439Z', 'M12-.023A12.023,12.023,0,1,0,24.022,12,12.036,12.036,0,0,0,12-.023ZM19.619,6.57a.85.85,0,0,1,1.152.349,9.888,9.888,0,0,1,.981,2.745.851.851,0,0,1-1.67.329,8.189,8.189,0,0,0-.812-2.271A.851.851,0,0,1,19.619,6.57ZM11.251,15.5a.75.75,0,0,1-1.5,0v-1a.25.25,0,0,0-.25-.25H7a.751.751,0,0,1-.728-.932l.811-3.242a1.748,1.748,0,0,1,1.7-1.326H10.5a.75.75,0,0,1,.75.75ZM15,11.749a2.25,2.25,0,1,1,0,4.5H13.5a.75.75,0,1,1,0-1.5H15a.75.75,0,0,0,0-1.5h-.813a1.439,1.439,0,0,1-1.437-1.438V9.5a.75.75,0,0,1,.75-.75h3a.75.75,0,0,1,0,1.5h-2a.25.25,0,0,0-.25.25V11.54a.25.25,0,0,0,.271.249Zm3.262-6.22a.851.851,0,0,1-1.2.148A8.23,8.23,0,0,0,6.036,17.829.851.851,0,1,1,4.8,19,9.932,9.932,0,0,1,18.115,4.334.852.852,0,0,1,18.263,5.529Zm1.4,12.4c-.141.171-.288.337-.439.5a.851.851,0,0,1-1.239-1.168c.126-.133.248-.271.366-.412a.851.851,0,1,1,1.312,1.083Zm1.792-3.255a.851.851,0,1,1-1.617-.53,8.176,8.176,0,0,0,.254-.991.851.851,0,1,1,1.672.317A9.678,9.678,0,0,1,21.456,14.673Z']],
  SmartHouseGarage: ['smart-house-garage', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.000 11.000 L18.000 11.000 L18.000 12.500 L12.000 12.500 Z', 'M12.000 8.500 L18.000 8.500 L18.000 10.000 L12.000 10.000 Z', 'M12.000 13.500 L18.000 13.500 L18.000 15.000 L12.000 15.000 Z', 'M23.772,6.882,15.416.15a.652.652,0,0,0-.832,0L6.228,6.882a.628.628,0,0,0-.189.7.643.643,0,0,0,.6.416H8.75A.25.25,0,0,1,9,8.25v6.116A.639.639,0,0,0,9.643,15H10.75a.25.25,0,0,0,.25-.25V8a.5.5,0,0,1,.5-.5h7A.5.5,0,0,1,19,8v6.75a.25.25,0,0,0,.25.25h1.107A.639.639,0,0,0,21,14.366V8.25A.25.25,0,0,1,21.25,8h2.107a.643.643,0,0,0,.6-.416A.628.628,0,0,0,23.772,6.882Z', 'M2.414,14.057a1.281,1.281,0,0,1,1.672,0,.75.75,0,1,0,1-1.114,2.819,2.819,0,0,0-3.68,0,.75.75,0,1,0,1,1.114Z', 'M6.219,10.793a4.871,4.871,0,0,0-5.938,0,.75.75,0,1,0,.938,1.17,3.3,3.3,0,0,1,4.062,0,.75.75,0,1,0,.938-1.17Z', 'M4.75,15.25h-3A1.752,1.752,0,0,0,0,17v5.25A1.752,1.752,0,0,0,1.75,24h3A1.752,1.752,0,0,0,6.5,22.25V17A1.752,1.752,0,0,0,4.75,15.25Zm.25,7a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25V17a.25.25,0,0,1,.25-.25h3A.25.25,0,0,1,5,17Z']]
};
exports["default"] = _default;